<template>
  <div class="mobile-banner-wrap">
    <div class="mobile-text" id="text1">从创业之初，</div>
    <div class="mobile-text" id="text2">
      我们就着手建立了一支全面而专业的团队。
    </div>
    <div class="mobile-user-box">
      <img class="mobile-user-ava" src="@/assets/home/user_ava.png" alt="" />
      <div class="mobile-user-info">
        <div class="mobile-user-name">闫丽琴</div>
        <div class="mobile-user-position">联合创始人</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        new this.Typed("#text1", {
          strings: ["从创业之初，"],
          typeSpeed: 100,
        });
        new this.Typed("#text2", {
          strings: ["我们就着手建立了一支全面而专业的团队。"],
          typeSpeed: 60,
        });
      });
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.mobile-banner-wrap {
  width: 100%;
  height: 65.625rem;
  padding: 4rem 3rem 6rem 3rem;
  background: url(~@/assets/mobile/home/banner.png) center center no-repeat;
  background-size: contain;
  .mobile-text {
    font-weight: 500;
    font-size: 2.125rem;
    color: #ffffff;
  }
  .mobile-user-box {
    margin-top: 1.75rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .mobile-user-ava {
      margin-right: 0.75rem;
      width: 4.375rem;
      height: 4.375rem;
    }
    .mobile-user-info {
      .mobile-user-name {
        font-weight: 500;
        font-size: 1rem;
        color: #ffffff;
      }
      .mobile-user-position {
        font-weight: 500;
        font-size: 1rem;
        color: #ffffff;
      }
    }
  }
}
</style>
